import { usePathname } from 'expo-router'

type PosScreen = 'product-catalog' | 'order-finalization'

export const usePosActiveScreen = (): PosScreen | undefined => {
    const pathname = usePathname()

    switch (pathname) {
        case '/pos/1-product-catalog':
            return 'product-catalog'
        case '/pos/2-order-finalization':
            return 'order-finalization'
        default:
            return undefined
    }
}
